import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { useId, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import AnchoredTooltip from "../overlays/AnchoredTooltip";
import { useAnchoredTooltip } from "../overlays/useAnchoredTooltip";

/**
 * What a setting does, on hover or focus of a small mark beside its name (IM-RULES: hints are
 * subtle, on hover or focus, the same everywhere; P-C: details on demand). The page shows names
 * and values; screen readers hear the explanation as the mark's description.
 */
export default function HoverHint({ name, children }: { name: string; children: ReactNode }) {
  const { t } = useTranslation();
  const hintId = useId();
  const tooltip = useAnchoredTooltip();
  return (
    <>
      <button type="button" aria-label={t("common.about", { name })} aria-describedby={hintId}
        className="app-text-muted inline-flex shrink-0 align-middle" {...tooltip.hoverProps()} {...tooltip.focusProps()}>
        <InformationCircleIcon className="h-4 w-4" aria-hidden="true" />
      </button>
      <span id={hintId} className="sr-only">{children}</span>
      {tooltip.shown === null ? null : <AnchoredTooltip anchor={tooltip.shown.anchor}>{children}</AnchoredTooltip>}
    </>
  );
}
